import { Button } from "@blueprintjs/core";
import { DateRangePicker } from "@blueprintjs/datetime";
import { Popover2 } from "@blueprintjs/popover2";
import React, { useCallback, useContext, useState } from "react";
import { DateRangeFilterContext } from "utils/context";

import "./RequestTimeRange.scss";

export default function RequestTimeRange() {
    const [open, setOpen] = useState(false);
    const [hovering, setHovering] = useState(false);
    const [filterRange, setFilterRange] = useContext(DateRangeFilterContext);
    const [currentFilter, setCurrentFilter] = useState(filterRange);

    const toggleHover = useCallback(() => {
        setHovering(!hovering);
    }, [hovering]);

    const toggle = useCallback(() => {
        setOpen(!open);
    }, [open]);

    const onApply = useCallback(() => {
        setFilterRange(currentFilter);
        toggle();
    }, [currentFilter, setFilterRange, toggle]);

    const onClear = useCallback(() => {
        setFilterRange([null, null]);
        setCurrentFilter([null, null]);
    }, [setFilterRange]);

    return (
        <Popover2
            enforceFocus={false}
            isOpen={open}
            content={
                <div className="close-header">
                    <div className="close-button">
                        <Button onClick={toggle} icon="cross" minimal />
                    </div>
                    <DateRangePicker
                        singleMonthOnly
                        highlightCurrentDay
                        value={currentFilter}
                        allowSingleDayRange
                        timePrecision="minute"
                        onChange={(dates) => setCurrentFilter(dates)}
                        onShortcutChange={(s) => setFilterRange(s.dateRange)}
                        maxDate={new Date()}
                        timePickerProps={{
                            useAmPm: true
                        }}
                    />
                    <div className="action-buttons">
                        <Button text="Clear" minimal onClick={onClear} />
                        <Button text="Apply" minimal intent="primary" onClick={onApply} />
                    </div>
                </div>
            }
            position="bottom"
            onClose={() => setOpen(false)}
        >
            <span
                className="ag-icon ag-icon-menu"
                onMouseEnter={toggleHover}
                onMouseLeave={toggleHover}
                onClick={toggle}
            ></span>
        </Popover2>
    );
}
